module.exports = __webpack_public_path__ + "static/media/summit-face-tip-2.1be2e4c8.svg";